export const localStoragePrefix = "rescuetablet:buergertelefon:";

export const apiEndpoint =
  import.meta.env.VITE_API_ENDPOINT ?? "https://app-api.rescuetablet.com";
